<template>
  <div>
    <ModuleHeader>Cuentas aperturadas desde mesa</ModuleHeader>
    <v-overlay v-if="loadingData">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-row>
      <v-col md="12" cols="12">
        <v-card rounded="xl" elevation="1">
          <v-card-text>
            <v-row>
              <v-col md="2" cols="12">
                <v-menu v-model="menuFechaInicial" :close-on-content-click="false" :nudge-right="40"
                  transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="input_date" label="Fecha Inicial" prepend-icon="mdi-calendar" readonly
                      v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="input_date" @input="menuFechaInicial = false"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col md="2">
                <v-menu v-model="menuFechaInicial2" :close-on-content-click="false" :nudge-right="40"
                  transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="input_date_final" label="Fecha Final" prepend-icon="mdi-calendar" readonly
                      v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="input_date_final" @input="menuFechaInicial2 = false"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col md="2">
                <v-select v-model="depto" :items="departamentos" :menu-props="{ maxHeight: '400' }" item-text="Nombre"
                  item-value="Id" label="Departamentos restaurante" persistent-hint></v-select>
              </v-col>
              <v-col class="text-right mt-n5" cols="12" md="12">
                <v-btn depressed @click="cleanFilter()" class="mx-2" color="error">
                  Restablecer Filtro
                </v-btn>
                <v-btn depressed @click="getAccounts()" color="success">
                  Buscar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="12">
        <v-card rounded="xl" elevation="1" cols="12">
          <v-card-text>
            <v-row>
              <v-col md="8"> Resultados </v-col>
              <v-col md="2" class="text-right"> </v-col>
              <v-col md="2" class="text-right"> </v-col>
              <v-col md="12"> </v-col>
            </v-row>
            <uv-data-table ref="accountsTable" :config="tableConfig" :data="accounts" :pageRows="15"
              @buttonClick="dtButtonClick"></uv-data-table>
            <!-- <v-simple-table>
              <thead>
                <tr>
                  <th>Mesa</th>
                  <th>Cliente</th>
                  <th>Alias</th>
                  <th>Mesero</th>
                  <th>Estatus</th>
                  <th>Fecha Apertura</th>
                  <th>Opciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="accounts.length == 0">
                  <td colspan="7">No se encontraron datos</td>
                </tr>
                <template v-for="(res, index) in accounts">
                  <tr :key="index">
                    <td>
                      <b>{{ res.Mesa.Nombre }}</b>
                    </td>
                    <td>
                      {{ res.Cliente }}<br />
                      <p class="text-caption">Identificador: {{ res.id }}</p>
                      <v-chip v-if="res.TicketImpreso" class="ma-2" small color="orange" dark label>
                        Ticket impreso
                      </v-chip>
                    </td>
                    <td>{{ res.Apodo }}</td>
                    <td>{{ res.Mesero }}</td>
                    <td style="white-space: nowrap">
                      <h4 v-if="res.Estatus == 0" class="blue--text">
                        Cobrada
                      </h4>
                      <h4 v-if="res.Estatus == 1" class="green--text">
                        Activa
                      </h4>
                      <h4 v-if="res.Estatus == -1" class="red--text">
                        Cancelada
                      </h4>
                    </td>
                    <td>{{ formatDate(res.Fecha) }}</td>
                    <td>
                      <v-btn color="success" outlined small @click="showProds(res.Catalogo)">Productos</v-btn>
                      <v-btn :loading="loadingLog" color="primary" class="mx-1" outlined small
                        @click="showLog(res._l, res.id)">Bitacora</v-btn>
                      <v-btn color="error" outlined small v-if="res.Estatus == 1"
                        @click="deleteCuenta(res.id)">Desactivar</v-btn>
                    </td>
                  </tr>
                </template>
              </tbody>
            </v-simple-table> -->
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="700" hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Productos</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-list dense>
          <v-subheader>Productos en esta cuenta</v-subheader>
          <template v-for="(prod, index) in CatalogoShow">
            <v-list-item dense :key="index">
              <v-list-item-content class="my-0">
                <v-list-item-title>{{ prod.Cnt }} {{ prod.Nombre }}</v-list-item-title>
                <p v-if="prod.ExtraParams && prod.ExtraParams.CuentaData" class="mt-0 caption">
                  CPI:{{ prod.ExtraParams.CuentaData.CPI }}
                </p>
                <div v-if="prod.ExtraParams && prod.ExtraParams.AYB">
                  <p v-if="prod.ExtraParams.AYB.Mesero" class="mt-0 mb-0 caption">
                    Mesero:{{ getMeseroName(prod.ExtraParams.AYB.Mesero) }}
                  </p>
                </div>
                <template v-for="(modi, indexMod) in prod.modificadoresList">
                  <v-list-item-subtitle :key="indexMod">
                    {{ modi.Cnt }} {{ modi.nam }}</v-list-item-subtitle>
                </template>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogLog" width="800" scrollable transition="dialog-bottom-transition">
      <v-card class="grey lighten-4">
        <v-toolbar dark color="primary" flat>
          <v-btn icon dark @click="dialogLog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Bitácora de Cuenta</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field v-model="searchLog" append-icon="mdi-magnify" label="Buscar en bitácora..." single-line
            hide-details dark dense outlined class="shrink" style="max-width: 250px"></v-text-field>
        </v-toolbar>

        <v-card-text class="pa-4">
          <v-alert v-if="filteredMergedLogs.length === 0" type="info" text dense class="mt-4">
            No se encontraron registros que coincidan con la búsqueda.
          </v-alert>

          <v-card v-for="(log, index) in filteredMergedLogs" :key="index" class="mb-4 elevation-1 rounded-lg">
            <v-sheet :color="log.accion ? 'blue-grey lighten-5' : 'blue lighten-5'" class="px-4 py-2 border-bottom">
              <div class="d-flex align-center">
                <v-icon small color="primary" class="mr-2">
                  {{
                    log.accion
                      ? "mdi-alert-circle-outline"
                      : "mdi-cart-arrow-right"
                  }}
                </v-icon>
                <span class="text-overline font-weight-bold grey--text text--darken-3">
                  {{
                    log.accion
                      ? "Movimiento a la cuenta"
                      : "Actividad de Productos"
                  }}
                </span>
                <v-spacer></v-spacer>
              </div>
            </v-sheet>

            <v-card-text class="pt-3">
              <v-row dense align="center">
                <v-col cols="12" sm="7">
                  <div class="d-flex align-center mb-1">
                    <v-avatar color="primary" size="24" class="mr-2">
                      <v-icon x-small dark>mdi-account</v-icon>
                    </v-avatar>
                    <div>
                      <span class="text-body-2 font-weight-bold d-block">{{
                        log.u.n
                        }}</span>
                      <span class="text-caption grey--text">{{ log.u.i }}</span><br />
                      <span class="text-caption grey--text">{{ log.u.t }}</span>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" sm="5" class="text-sm-right border-left-sm">
                  <div class="d-flex align-center justify-sm-end">
                    <v-icon small color="grey lighten-1" class="mr-1">mdi-calendar-clock</v-icon>
                    <span class="text-caption grey--text text--darken-2 font-weight-medium">{{ formatDate(log.t)
                      }}</span>
                  </div>
                </v-col>
              </v-row>

              <v-expand-transition>
                <div v-if="log.m && log.m.length > 0">
                  <v-divider class="my-3"></v-divider>
                  <div v-for="(mov, indexMov) in log.m" :key="indexMov" class="mb-2 pa-2 rounded grey lighten-5">
                    <div class="d-flex align-start">
                      <v-icon small class="mr-2 mt-1" :color="mov._PC > 0 ? 'success' : 'error'">
                        {{
                          mov._PC > 0 ? "mdi-plus-circle" : "mdi-minus-circle"
                        }}
                      </v-icon>
                      <div style="width: 100%">
                        <div class="d-flex justify-space-between align-center">
                          <span class="text-body-2">
                            <b :class="mov._PC > 0 ? 'success--text' : 'error--text'
                              ">
                              {{ mov._PC > 0 ? "Agregó" : "Eliminó" }}
                            </b>
                            <b> ({{ Math.abs(mov._PC) }})</b> {{ mov.Nombre }}
                          </span>
                        </div>

                        <!-- List of modifiers if any -->
                        <div v-if="
                          mov.modificadoresList &&
                          mov.modificadoresList.length > 0
                        " class="mt-1 d-flex flex-wrap">
                          <v-chip v-for="(modi, indexModi) in mov.modificadoresList" :key="indexModi" x-small outlined
                            class="mr-1 mb-1" color="grey lighten-1">
                            <span class="grey--text text--darken-2">En cada item: {{ modi.Cnt / mov._PC }} x {{ modi.nam
                              }} || Total: {{ modi.Cnt }}</span>
                          </v-chip>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mb-2 pa-2 rounded grey lighten-5">
                  <div class="d-flex align-start">
                    <div v-if="log.accion" class="d-flex justify-space-between align-center">
                      <span class="text-body-2">
                        <b>
                          {{ log.accion }}
                        </b>
                      </span>
                    </div>
                  </div>
                </div>
              </v-expand-transition>
            </v-card-text>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped></style>

<script>
import moment from "moment";
import uvDataTable from "../../MainComponents/DataTable.vue";

export default {
  name: "CAYB",
  components: {
    uvDataTable,
    /*Select2,*/
  },
  props: ["hideMenu"],
  data() {
    return {
      config: {
        orderByCol: { Field: "", Type: "Asc" },
        selectableRow: true,
        allowExport: true,
        rawText: "Cuentas aperturadas desde mesa",
        selectConfig: {
          idRowData: "id",
        },
        buttons: [],
        fields: [
          {
            text: "Identificador",
            value: "Id",
            canBeFiltered: true,
            format: (row) => {
              return row.id || "N/A";
            },
          },
          {
            text: "Mesa",
            value: "MesaNombre",
            canBeFiltered: true,
          },
          {
            text: "Cliente",
            value: "Cliente",
            canBeFiltered: true,
            format: (row) => {
              return row.Cliente || "N/A";
            },
          },
          {
            text: "Ticket impreso",
            value: "TicketImpreso",
            canBeFiltered: true,
            format: (row) => {
              if (row.TicketImpreso) {
                return "Impreso";
              }
              return "No";
            },
          },
          {
            text: "Alias",
            value: "Apodo",
            canBeFiltered: true,
            format: (row) => {
              return row.Apodo || "N/A";
            },
          },
          {
            text: "Mesero",
            value: "Mesero",
            canBeFiltered: true,
            format: (row) => {
              return row.Mesero || "N/A";
            },
          },
          {
            text: "Estatus",
            value: "EstatusText",
            canBeFiltered: true,
            format: (row) => {
              return this.getAccountStatusLabel(row.Estatus);
            },
          },
          {
            text: "Fecha Apertura",
            value: "Fecha",
            format: (row) => {
              return this.formatDate(row.Fecha);
            },
          },
          {
            text: "Opciones",
            value: "id",
            buttons: [
              {
                color: "success",
                text: "Productos",
                buttonId: "showProducts",
                value: "id",
              },
              {
                color: "primary",
                text: "Bitacora",
                buttonId: "showLog",
                value: "id",
                doLoading: true,
              },
              {
                color: "error",
                text: "Desactivar",
                buttonId: "deactivateAccount",
                value: "id",
                showBy: "canDeactivate",
              },
            ],
          },
        ],
      },
      loadingLog: false,
      depto: null,
      departamentos: [],
      meseros: [],
      menuFechaInicial: false,
      menuFechaInicial2: false,
      loadingData: false,
      dialog: false,
      dialogLog: false,
      getAybCuentas: [],
      input_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      input_date_final: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000,
      )
        .toISOString()
        .substr(0, 10),
      CatalogoShow: [],
      logShow: [],
      accountActionsLog: [],
      searchLog: "",
    };
  },
  computed: {
    tableConfig() {
      return {
        ...this.config,
      };
    },
    disableDates() {
      return { to: new Date(this.input_date) };
    },
    items() {
      let data = [];
      if (this.search != "" && this.search) {
        data = this.accounts.filter((acc) => {
          if (
            acc?.Descripcion?.toUpperCase().includes(this.search.toUpperCase())
          ) {
            return true;
          } else {
            return false;
          }
        });
      }
      return data;
    },
    comp_mesa() {
      return [];
    },
    accounts() {
      try {
        let accounts = [];
        this.getAybCuentas.forEach((element) => {
          //element.AcccountName = element.Cliente.Nombre
          if (element.Cliente) {
            let totalAccount = 0;
            element.Catalogo.forEach((prod) => {
              let precio = parseFloat(prod.Precio) * prod.Cantidad;
              prod.Descuentos.forEach((desc) => {
                // verifica los precios quitando los descuentos aplicados por otras promociones
                if (desc.Activo) {
                  precio = precio + desc.Cnt * desc.Cur.C;
                }
              });
              if (element.modificadoresList) {
                element.modificadoresList.forEach((modi) => {
                  // verifica los modificadores aplicados al producto
                  precio = precio + modi.pco.C * modi.Cnt;
                });
              }
              totalAccount += precio;
            });
            let text =
              element.Contenedor.Nombre + " - " + element.Cliente.Nombre;
            if (element.Cliente.Apodo !== "" && element.Cliente.Apodo) {
              text = text + " (" + element.Cliente.Apodo + ")";
            }
            if (totalAccount > 0) {
              text =
                text +
                " || Total: " +
                totalAccount +
                " " +
                this.$Currencies.getCurrencyDefault();
            }

            if (element.DAYB === this.depto) {
              accounts.push({
                id: element.id,
                Descripcion: text,
                Apodo: element.Cliente.Apodo,
                Cliente: element.Cliente.Nombre,
                Mesero: element.Mesero.Nombre,
                MesaId: element.Contenedor.Id,
                Mesa: element.Contenedor,
                MesaNombre: element.Contenedor
                  ? element.Contenedor.Nombre
                  : "N/A",
                TicketImpreso: element.TicketImpreso,
                depto: element.DAYB,
                Estatus: element.Estatus,
                EstatusText: this.getAccountStatusText(element.Estatus),
                canDeactivate: element.Estatus == 1,
                Fecha: element.FechaCreacion,
                Catalogo: element.Catalogo,
                _l: element._l,
              });
            }
          }
          // accounts.push({cliente:element.Cliente.Nombre});
        });

        let array = accounts.sort(function (a, b) {
          if (b.Fecha > a.Fecha) return -1;
          if (b.Fecha < a.Fecha) return 1;
        });
        return array;
      } catch (e) {
        return [];
      }
    },
    mergedLogs() {
      const logsFromRes = (this.logShow || []).map((log) => ({
        ...log,
        timestamp: log.t ? new Date(log.t).getTime() : 0,
      }));

      const logsFromActions = (this.accountActionsLog || []).map((log) => ({
        u: {
          n: log.empleado?.nm || "Desconocido",
          t: log.empleado?.tp || "N/A",
          i: log.empleado?.id || "",
        },
        t: log.fecha,
        m: [],
        accion: log.accion,
        timestamp: log.fecha ? new Date(log.fecha).getTime() : 0,
      }));

      return [...logsFromRes, ...logsFromActions].sort(
        (a, b) => a.timestamp - b.timestamp,
      );
    },
    filteredMergedLogs() {
      if (!this.searchLog) return this.mergedLogs;
      const search = this.searchLog.toLowerCase();
      return this.mergedLogs.filter((log) => {
        const userName = log.u?.n?.toLowerCase() || "";
        const userType = log.u?.t?.toLowerCase() || "";
        const action = log.accion?.toLowerCase() || "";
        const date = this.formatDate(log.t).toLowerCase();

        let movementMatches = false;
        if (log.m) {
          movementMatches = log.m.some(
            (mov) =>
              mov.Nombre?.toLowerCase().includes(search) ||
              (mov._PC > 0 ? "agrego" : "elimino").includes(search),
          );
        }

        return (
          userName.includes(search) ||
          userType.includes(search) ||
          action.includes(search) ||
          date.includes(search) ||
          movementMatches
        );
      });
    },
  },
  methods: {
    async dtButtonClick(buttonId, idSelected) {
      const selectedId = Array.isArray(idSelected) ? idSelected[0] : idSelected;
      let account =
        this.$pgsHelper.getById(this.getAybCuentas, "id", selectedId) ||
        this.$pgsHelper.getById(this.accounts, "id", selectedId);

      if (!account) {
        return;
      }

      const baseButtonId = buttonId.split("-")[0];

      if (baseButtonId === "showProducts") {
        console.log(account.Catalogo)
        this.showProds(account.Catalogo || []);
        return;
      }

      if (baseButtonId === "showLog") {
        await this.showLog(account._l || [], account.id);
        this.$refs.accountsTable?.stopLoading(buttonId);
        return;
      }

      if (baseButtonId === "deactivateAccount") {
        await this.deleteCuenta(account.id);
      }
    },
    getAccountStatusText(status) {
      if (status === 0) {
        return "Cobrada";
      }
      if (status === 1) {
        return "Activa";
      }
      if (status === -1) {
        return "Cancelada";
      }
      return "Sin estatus";
    },
    getAccountStatusLabel(status) {
      if (status === 0) {
        return '<span class="blue--text font-weight-bold">Cobrada</span>';
      }
      if (status === 1) {
        return '<span class="green--text font-weight-bold">Activa</span>';
      }
      if (status === -1) {
        return '<span class="red--text font-weight-bold">Cancelada</span>';
      }
      return this.getAccountStatusText(status);
    },
    async deleteCuenta(id) {
      let datos = {};
      datos.Id = id;
      datos.DeptoAYB = this.depto;
      // console.log("Eliminar cuenta de mesa", datos);
      this.$swal({
        title: "¿Deseas desactivar la cuenta de esta mesa?",
        text: "Se desactivará la cuenta",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Desactivar Cuenta",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("AYB-Cuentas-desactivarCuenta", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then(async (result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.getAccounts();
          } else {
            this.$swal(
              "Error desactivando cuenta",
              result.value.data.error,
              "error",
            );
          }
        }
      });
    },

    async getAccountLogs(id) {
      this.loadingLog = true;
      let result = await this.$store.getters.getFirebaseApp.fba.call(
        "AYB-Cuentas-getHistorial",
        { cuentaId: id, tenant: this.$store.getters.tenant },
      );
      console.log("result", result);
      if (result.data.ok) {
        this.loadingLog = false;
        return result.data.data;
      }
      this.loadingLog = false;
      return [];
    },

    getMeseroName(id) {
      let mesero = this.$pgsHelper.getById(this.meseros, "id", id);
      if (mesero) {
        return mesero.Nombre;
      } else {
        return "N/A";
      }
    },
    showProds(catalogo) {
      this.CatalogoShow = catalogo;
      this.dialog = true;
    },
    async showLog(log, id) {
      this.logShow = log;
      this.accountActionsLog = await this.getAccountLogs(id);
      this.dialogLog = true;
    },
    formatDate(timestamp) {
      let d = new Date(timestamp);
      //console.log(new moment(d))
      //let Creacion =   d.getDate()  + "-" + (d.getMonth()+1) + "-" + d.getFullYear() + " " + d.getHours() + ":" + d.getMinutes();
      return new moment(d).format("YYYY-MM-DD HH:mm");
    },
    async getDepartamentosAB() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "AYB/Departamentos",
        );
      if (snapshot.exists()) {
        this.departamentos = [];
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            this.departamentos.push(toAdd);
          }
        });
      }
    },
    cleanFilter() {
      this.input_date = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000,
      )
        .toISOString()
        .substr(0, 10);
      this.input_date_final = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000,
      )
        .toISOString()
        .substr(0, 10);
    },
    selectDate(arg) {
      this.input_date = moment(arg);
      this.input_date_final = moment(arg);
    },
    selectDateFinal(arg) {
      this.input_date_final = moment(arg);
    },
    async getAccounts() {
      this.getAybCuentas = [];

      const startDate = new moment(this.input_date).format(
        "YYYY-MM-DD 00:00:00",
      );
      const endDate = new moment(this.input_date_final).format(
        "YYYY-MM-DD 23:59:59",
      );
      const startMlsc = new moment(startDate).valueOf();
      const endMlsc = new moment(endDate).valueOf();

      /*const end = endDate.replace(/.$/, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 1)
      );*/
      let cuentas = [];

      const firestore = this.$store.getters.getFirebaseApp.firestore;
      const wheres = [
        firestore.where("FechaCreacion", ">=", startMlsc),
        firestore.where("FechaCreacion", "<", endMlsc),
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant,
        ),
      ];
      if (this.depto) {
        wheres.push(firestore.where("DAYB", "==", this.depto));
      }
      const data = await firestore.queryBuilder("AYB_Cuentas", wheres);

      cuentas = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });
      console.log(cuentas)
      this.getAybCuentas = cuentas;
    },
    async getMeserosAB() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "AYB/Meseros",
        );
      if (snapshot.exists()) {
        this.meseros = [];
        this.meseros = this.$pgsHelper.ArrayObjectToArray(snapshot.val());
        this.meseros.forEach((mesero) => {
          if (mesero.Deptos) {
            let deptos = Object.entries(mesero.Deptos);
            let textDepto = "";
            deptos.forEach((depto) => {
              let testDepto = this.$pgsHelper.getById(
                this.departamentos,
                "Id",
                depto[0],
              );
              if (testDepto) {
                textDepto = textDepto + testDepto.Nombre + " ";
              }
            });
            mesero.DepartamentoText = textDepto;
          } else {
            mesero.DepartamentoText = "";
          }
        });
      }
    },
  },
  async mounted() {
    await this.getDepartamentosAB();
    if (this.departamentos.length > 0) {
      this.depto = this.departamentos[0].Id;
    }
    await this.getMeserosAB();
  },
};
</script>

<style>
.input input {
  border-bottom: 1px solid black;
  width: 100%;
}
</style>
